<template>
  <ReportForecastComponent :urls="urls" :mandatory-filter="mandatoryFilter" />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportForecastComponent from "@/own/components/reports/ReportForecastComponent.vue";
export default {
  name: "InboundOutboundForecast",
  components: { ReportForecastComponent },
  data: () => ({
    urls: {
      data_url: "reports/reportForecast",
      show_url: "/reports/reportForecast/show",
    },
  }),
  computed: {
    mandatoryFilter() {
      return [
        { name: "client", title: this.$t("seller"), valueFieldName: "" },
        { name: "type", title: this.$t("type"), valueFieldName: "" },
        { name: "year", title: this.$t("year"), valueFieldName: "" },
      ];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
